import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController, AlertController } from 'ionic-angular';
import { OrdenProvider } from '../../providers/orden/orden';
import { AuthProvider } from '../../providers/auth/auth';
import { editOrder, Order } from '../../models/order';
import { OrdensPage } from '../ordens/ordens';

/**
 * Generated class for the EditOrdenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edit-orden',
  templateUrl: 'edit-orden.html',
})
export class EditOrdenPage {
  
  data: editOrder = {
    dias_cita: ''
  };
  id: any;

  constructor(  
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private orderProvider: OrdenProvider,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    public navParams: NavParams) {
  }
  
  ngOnInit() {
    this.id = this.navParams.get('id');
    console.log('ionViewDidLoad EditOrdenPage');
  }

  goOrden() {


    this.alertCtrl.create({
      subTitle: '¿Estas seguro, quieres cambiar los dias de seguimiento?',
      buttons: [
        'Cancelar',
        {
          text: 'Si',
          handler: () => {

            let loading = this.loadingCtrl.create({
              content: 'cambiando datos...'
            });

            loading.present();
            console.log(this.data);
            this.orderProvider.editOrder(this.id, this.data)
              .subscribe((res: Order) => {
                  loading.dismiss();
                  console.log(res);
                  if (res.id) {
                    this.navCtrl.setRoot(OrdensPage);
                  }
                },
                (err) => {
                  loading.dismiss();
                  console.log("ERROR: ", err);
                })

            // this.navCtrl.push(DetalleOrdenPage, this.data);
          }
        }
      ]
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/edit-orden/edit-orden.ts